import { config } from 'util/config';
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';

// 选择模块过滤器后：记录 moduleId（供新增表单预填 + 分组接口），刷新本 section 列表
export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { moduleId: parameter } });
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ searchParameter: { moduleId: parameter }, componentDefaultValue });
  setTimeout(() => {
    sectionComponent.getSectionDataByDefault();
  }, config.setTimeoutMilliSecond);
}

// 把当前模块已加载的分组（来自 GetGroupList，已按 CompanyId+ModuleId 隔离）注入新增/编辑表单的 Group 下拉
// 避免依赖后端 datasource（该页不向表单传 moduleId），同时保证下拉只含本模块分组
function injectGroupOptions(sectionComponent) {
  let table = sectionComponent.child?.current;
  let groups = (table?.state?.data || []).filter(g => g.CompanyDocumentFolderGroupId !== 0); // 排除虚拟 Default 组
  let options = [{ Key: '- No Group -', Value: 0 }];
  groups.forEach(g => options.push({ Key: g.Name, Value: g.CompanyDocumentFolderGroupId }));
  let componentDataSource = { ...(sectionComponent.customForm.current?.state.componentDataSource || {}) };
  componentDataSource['CompanyDocumentFolderGroupId'] = options;
  sectionComponent.customForm.current?.setState({ componentDataSource });
}

// 打开"分组管理"弹窗（topButton onClick）：sectionComponent = DefaultSection，真正的表格 = sectionComponent.child.current
export function manageCompanyDocumentFolderGroup({ sectionComponent } = {}) {
  const table = sectionComponent.child?.current;
  if (!table) return;
  table.setState({ manageGroupShow: true });
  setTimeout(() => {
    table.manageGroup?.current?.getCompanyDocumentFolderGroupList();
  }, config.setTimeoutMilliSecond);
}

// 给某个分组添加文件夹（组内"+"按钮）：走通用 addBySection，分组预填在 addCompanyDocumentFolderPopUpRun 里处理
export function addCompanyDocumentFolder({ parameter, sectionComponent, pageComponent } = {}) {
  operationalFunction({ functionName: 'addBySection', sectionName: 'CompanyDocumentFolder', parameter: parameter, sectionComponent: sectionComponent, pageComponent: pageComponent });
}

// 新增表单打开后回调（通用 addBySection 末尾自动调用）：注入分组下拉 + 预填所属分组
export function addCompanyDocumentFolderPopUpRun({ parameter, sectionComponent } = {}) {
  injectGroupOptions(sectionComponent);
  // parameter.CompanyDocumentFolderGroupId 来自组内"+"（Default 组为 0=不分组）；普通"Add Folder"默认 0
  let groupId = parameter && parameter.CompanyDocumentFolderGroupId !== undefined ? parameter.CompanyDocumentFolderGroupId : 0;
  sectionComponent.customForm.current?.formRef.current?.setFieldValue('CompanyDocumentFolderGroupId', groupId);
}

// 编辑表单打开后回调（通用 editBySection 末尾自动调用）：注入分组下拉 + 把未分组(null)显示为 "- No Group -"(0)
export function editCompanyDocumentFolderPopUpRun({ sectionComponent, data } = {}) {
  injectGroupOptions(sectionComponent);
  if (data && (data.CompanyDocumentFolderGroupId === null || data.CompanyDocumentFolderGroupId === undefined)) {
    sectionComponent.customForm.current?.formRef.current?.setFieldValue('CompanyDocumentFolderGroupId', 0);
  }
}
